import React, { memo } from "react";
import { Stack, Typography } from "investira.react.components";
import { PessoaImage, ModalInfo } from "../../../../../components/molecules";
import { validators } from "investira.sdk";
import { displays } from "investira.react.lib";
import { useEmpresasContext } from "../../../../../contexts/EmpresasContext";
import EmpresaSetores from "../EmpresaSetores";

const METRICAS = {
  cs: "Capital Social",
  pl: "Patrimônio Líquido",
  market_value: "Valor de Mercado",
};

const PessoaItem = memo((props) => {
  const { actions } = useEmpresasContext();
  const { data, onClick, metrica } = props;

  return (
    <Stack
      direction="row"
      flexGrow={1}
      spacing={3}
      alignItems="center"
      component="li"
      onClick={onClick}
      sx={{
        px: 2,
        py: 2,
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "background.main",
        },
      }}
    >
      <Stack>
        <PessoaImage
          logoPessoaId={data.logo_pessoa_id}
          alt={data.pessoa_fantasia || data.pessoa}
          hasLogo={data.logo_ok}
          size={36}
        />
      </Stack>

      <Stack flexGrow={1} spacing={0.5}>
        <Typography
          variant="body2"
          color="textPrimary"
          sx={{ fontWeight: 600 }}
        >
          {data.pessoa_fantasia || data.pessoa}
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          {data.pessoa_fantasia && data.pessoa !== data.pessoa_fantasia && (
            <Typography variant="caption" color="textSecondary">
              {data.pessoa}
            </Typography>
          )}
          {data.cnpj && (
            <Typography variant="caption" color="textSecondary">
              {displays.cnpj(data.cnpj)}
            </Typography>
          )}
        </Stack>
        {!validators.isNull(data.metrica?.[metrica]) && (
          <Stack direction="row" spacing={0.5} alignItems="baseline">
            <Typography variant="caption" color="textSecondary">
              {`${METRICAS[metrica]}:`}
            </Typography>
            <Typography
              variant="body2"
              color="textPrimary"
              sx={{ fontWeight: 600 }}
            >
              {actions.formatNumber(data.metrica[metrica], true, true, 2, null)}
            </Typography>
          </Stack>
        )}
      </Stack>
      <Stack onClick={(e) => e.stopPropagation()}>
        <ModalInfo
          label="Setores"
          value={data.top_setor}
          modalProps={{
            pessoaId: data.pessoa_id,
          }}
          modalContent={EmpresaSetores}
          type="row"
          divider={false}
        />
      </Stack>
    </Stack>
  );
});

export default PessoaItem;
